import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

import { PageHeaderTop } from './PageHeaderTop';
import { PageHeaderBottom } from './PageHeaderBottom';

const Header = styled('div', {
  static: {
    boxShadow: '0px 1px 10px lightgrey',
  },
  dynamic: ({ zIndex, position, height, isSticky, bottomMargin }) => {
    return {
      zIndex,
      position,
      height,
      marginTop: isSticky ? 0 : null,
      borderBottom: isSticky ? '1px solid $gray4' : 'none',
      marginBottom: bottomMargin || (isSticky ? '25px' : '30px'),
    };
  },
});

export const PageHeader = ({
  children,
  actions,
  showBackButton,
  customGoBack,
  isSticky,
  backButtonContainer,
  position,
  height,
  zIndex,
  bottomMargin,
  noTitle,
  ...props
}) => {
  return (
    <Header
      height={height}
      position={position}
      zIndex={zIndex}
      bottomMargin={bottomMargin}
      {...props}
    >
      <PageHeaderTop actions={actions} />
      {noTitle !== true && (
        <PageHeaderBottom
          showBackButton={showBackButton}
          customGoBack={customGoBack}
          isSticky={isSticky}
          backButtonContainer={backButtonContainer}
        >
          {children}
        </PageHeaderBottom>
      )}
    </Header>
  );
};

PageHeader.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.shape({}),
  actions: PropTypes.arrayOf(PropTypes.node),
  showBackButton: PropTypes.bool,
  customGoBack: PropTypes.func,
  isSticky: PropTypes.bool,
  backButtonContainer: PropTypes.string,
  position: PropTypes.string,
  height: PropTypes.string,
  zIndex: PropTypes.number,
  bottomMargin: PropTypes.string,
  noTitle: PropTypes.bool,
};

PageHeader.defaultProps = {
  children: null,
  styles: null,
  actions: null,
  showBackButton: true,
  customGoBack: null,
  isSticky: false,
  backButtonContainer: null,
  height: 'auto',
  position: 'static',
  zIndex: 0,
  bottomMargin: null,
  noTitle: false,
};
